import { render, staticRenderFns } from "./SSCEDetails.vue?vue&type=template&id=e2dad5a6&scoped=true"
import script from "./SSCEDetails.vue?vue&type=script&lang=js"
export * from "./SSCEDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2dad5a6",
  null
  
)

export default component.exports